import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { jointReportActions } from "_actions";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import { useForm } from "react-hook-form";
import moment from "moment";
import roleGroups from "_views/Dashboard/_data/roleGroups";
import roles from "_views/Dashboard/_data/roleIdEnum";
import StandardB1 from "./components/StandardView";
import DirectorB1 from "./components/DirectorView";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "scroll",
  },
}));

export default function Index({ openModal, setOpenModal }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { control, watch } = useForm();

  const handleClose = () => {
    setOpenModal(!openModal);
  };
  
  const currentDate = moment().tz("America/New_York");
  const watchDate = watch("startDate", currentDate.startOf("week").format("MM/DD/YYYY"));
  const lobCurrent = useSelector((state) => state?.lob?.current);
  const auth = useSelector((state) => state?.auth?.role);

  useEffect(() => {
    if (openModal && watchDate) {
      dispatch(jointReportActions.getScoreboard(watchDate));
    }
  }, [lobCurrent, dispatch, watchDate, auth, openModal]);

  const selectedTheme = useSelector((state) => state?.settings?.theme);
  const roleId = useSelector((state) => state?.auth?.role?.roleId);
  const header = useSelector((state) => state?.joint?.reports?.scoreboard?.header);
  const regions = useSelector((state) => state?.joint?.reports?.scoreboard?.targets);
  const stats = useSelector((state) => state?.joint?.reports?.scoreboard?.stats);
  const directorView = useSelector((state) => state?.joint?.reports?.scoreboard?.directorView);

  const [sortedRegions, setSortedRegions] = useState([]);
  const [filteredRegions, setFilteredRegions] = useState([]);
  const [selectedView, setSelectedView] = useState("standard");

  useEffect(() => {
    if (directorView) {
      setSelectedView("director");
    }
  },[directorView]);

  useEffect(() => {
    if (regions) {
      setSortedRegions([
        ...regions.filter(r => r.regionid !== 3),
        ...regions.filter(r => r.regionid === 3)
      ]);
    }
  }, [regions]);


  useEffect(() => {
    setSelectedRegions(sortedRegions.map(r => r.regionid));
    setFilteredRegions(sortedRegions);
  }, [sortedRegions]);

  // sort by marketName alphabetically
  let statsSorted = stats
    ? [...stats].sort(function (a, b) {
        var textA = a.marketName.toUpperCase();
        var textB = b.marketName.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      })
    : [];

  const [teamBreakdown, setTeamBreakdown] = useState();

  let clearTeamBreakdown = () => {
    setTeamBreakdown();
  };

  const [weekOptions, setWeekOptions] = useState([]);
  const [weekOptionsSchema, setWeekOptionsSchema] = useState({});

  useEffect(() => {
    const weeks = new Array(94).fill(null).map((_, i) => {
      const startOfWeek = currentDate.clone().startOf("week").subtract(i, "weeks");
      const endOfWeek = currentDate.clone().endOf("week").subtract(i, "weeks");
      return {
        label: `Sun. ${startOfWeek.format("MM/DD/YYYY")} - Sat. ${endOfWeek.format("MM/DD/YYYY")}`,
        value: startOfWeek.format("MM/DD/YYYY"),
      };
    });

    const options = weeks.map((week) => week.value);
    const optionSchema = weeks.reduce((acc, cur) => {
      acc[cur.value] = cur;
      return acc;
    }, {});

    setWeekOptions(options);
    setWeekOptionsSchema(optionSchema);
  }, []);


  const [selectedRegions, setSelectedRegions] = useState([]);

  const toggleRegion = (regionId) => {
    if (selectedRegions.includes(regionId)) {
      if (selectedRegions.length === 1) return; // Prevent deselecting the last region
      setSelectedRegions((prev) => prev.filter((id) => id !== regionId));
      setFilteredRegions((prev) => sortedRegions.filter((region) => region.regionid !== regionId && prev.some(r => r.regionid === region.regionid)));
    } else {
      setSelectedRegions((prev) => [...prev, regionId]);
      setFilteredRegions((prev) => sortedRegions.filter((region) => region.regionid === regionId || prev.some(r => r.regionid === region.regionid)));
    }
  }

  const [isRestricted, setIsRestricted] = useState(false);

  useEffect(() => {
    setIsRestricted(roleGroups.PG_EXTERNAL.includes(roleId));
  }, [roleId]);


  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openModal}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
    <>
    <DirectorB1
        openModal={openModal}
        setOpenModal={setOpenModal}
        currentDate={currentDate}
        weekOptions={weekOptions}
        weekOptionsSchema={weekOptionsSchema}
        isRestricted={isRestricted}
        filteredRegions={filteredRegions}
        statsSorted={statsSorted}
        teamBreakdown={teamBreakdown}
        setTeamBreakdown={setTeamBreakdown}
        clearTeamBreakdown={clearTeamBreakdown}
        selectedTheme={selectedTheme}
        handleClose={handleClose}
        sortedRegions={sortedRegions}
        toggleRegion={toggleRegion}
        selectedRegions={selectedRegions}
        control={control}
        selectedView={selectedView}
        setSelectedView={setSelectedView}
    />
    <StandardB1
        openModal={openModal}
        setOpenModal={setOpenModal}
        currentDate={currentDate}
        weekOptions={weekOptions}
        weekOptionsSchema={weekOptionsSchema}
        isRestricted={isRestricted}
        filteredRegions={filteredRegions}
        statsSorted={statsSorted}
        teamBreakdown={teamBreakdown}
        setTeamBreakdown={setTeamBreakdown}
        clearTeamBreakdown={clearTeamBreakdown}
        selectedTheme={selectedTheme}
        handleClose={handleClose}
        sortedRegions={sortedRegions}
        toggleRegion={toggleRegion}
        selectedRegions={selectedRegions}
        control={control}
        selectedView={selectedView}
        setSelectedView={setSelectedView}
        directorView={directorView}
      />
      </>
    </Modal>
  );
}
